module.exports = __webpack_public_path__ + "static/img/phone-warning.0dff7aac.gif";